const DISPLAY_CACHE_KEY = 'user_display';

export function setCachedDisplay(user: {
  firstName?: string;
  lastName?: string;
}) {
  try {
    const initials =
      (user?.firstName?.[0] ?? '').toUpperCase() +
        (user?.lastName?.[0] ?? '').toUpperCase() || '';
    localStorage.setItem(DISPLAY_CACHE_KEY, JSON.stringify({ initials }));
  } catch {}
}

export function getCachedDisplay(): { initials: string } | null {
  try {
    const raw = localStorage.getItem(DISPLAY_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCachedDisplay() {
  try {
    localStorage.removeItem(DISPLAY_CACHE_KEY);
  } catch {}
}
